import { TEDrawerSection, TEInput } from '@timeedit/ui-components';
import './index.scss';

interface CommentsProps {
  value: string;
  onChange: (val: string) => void;
  disabled?: boolean;
}

const Comments = ({ value, onChange, disabled = false }: CommentsProps) => {
  return (
    <TEDrawerSection label="Comments">
      <div className="comments">
        <TEInput.TextArea
          value={value}
          disabled={disabled}
          onChange={onChange}
          className="textarea"
          data-testid="comments"
        />
      </div>
    </TEDrawerSection>
  );
};

export default Comments;
